import { uniq, flatten, values } from 'lodash';
import { createSelector } from 'reselect';

import { latestImageBaselinesActionTypes } from './../actions/types';

const latestImageBaselines = (state = {}, action) => {
  switch (action.type) {
    case latestImageBaselinesActionTypes.success:
      return action.response;
    default:
      return state;
  }
};
export default latestImageBaselines;

export const getLatestImageBaselines = state => state.latestImageBaselines;
export const latestImageBaselineBuildIds = createSelector(
  getLatestImageBaselines,
  (imageBaselines) => uniq(flatten(values(imageBaselines)))
);
export const latestImageBaselineJobIds = createSelector(
  getLatestImageBaselines,
  (imageBaselines) => Object.keys(imageBaselines).map(x => +x)
);


// WEBPACK FOOTER //
// src/reducers/latestImageBaselines.js